module.exports = __webpack_public_path__ + "static/media/b1@2x.1a7debb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/b1@2x.png
// module id = 225
// module chunks = 0